import PropTypes from 'prop-types';
import icons from './icons';

export const iconPropTypes = {
  /**
   * The type of the icon to render.
   * Must match a key from the `icons` module.
   * @type {string}
   * @required
   */
  type: PropTypes.oneOf(Object.keys(icons)).isRequired,
  /**
   * The size of the icon.
   * Can be one of 'small', 'medium', 'large', or a custom string.
   * @type {('small'|'medium'|'large'|string)}
   */
  fontSize: PropTypes.oneOfType([
    PropTypes.oneOf(['small', 'medium', 'large']),
    PropTypes.string,
  ]),
  /**
   * The color of the icon.
   * Can be one of 'primary', 'secondary', or a custom color string.
   * @type {('primary'|'secondary'|string)}
   */
  color: PropTypes.oneOfType([
    PropTypes.oneOf(['primary', 'secondary']),
    PropTypes.string,
  ]),
  /**
   * The background color of the icon.
   * Can be one of 'primary', 'secondary', or a custom color string.
   * @type {('primary'|'secondary'|string)}
   */
  backgroundColor: PropTypes.oneOfType([
    PropTypes.oneOf(['primary', 'secondary']),
    PropTypes.string,
  ]),
  /**
   * The shape of the icon's background.
   * Can be 'square', 'square-rounded', or 'circle'.
   * @type {('square'|'square-rounded'|'circle')}
   */
  backgroundShape: PropTypes.oneOf(['square', 'square-rounded', 'circle']),
  /**
   * The width of the icon's background.
   * Can be a string or number, e.g., '50px' or 50.
   * @type {string|number}
   */
  backgroundWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * The height of the icon's background.
   * Can be a string or number, e.g., '50px' or 50.
   * @type {string|number}
   */
  backgroundHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * The size of the border around the icon.
   * Can be a string or number, e.g., '2px' or 2.
   * @type {string|number}
   */
  borderSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * The color of the border around the icon.
   * Can be one of 'primary', 'secondary', or a custom color string.
   * @type {('primary'|'secondary'|string)}
   */
  borderColor: PropTypes.oneOfType([
    PropTypes.oneOf(['primary', 'secondary']),
    PropTypes.string,
  ]),
  /**
   * Whether to render the background or not.
   * If false, only the icon is rendered without background.
   * @type {boolean}
   */
  hasBackground: PropTypes.bool,
};

export const iconDefaultProps = {
  type: 'car',
  fontSize: '58px',
  color: 'inherit',
  backgroundColor: 'transparent',
  backgroundShape: 'square',
  backgroundWidth: 'auto',
  backgroundHeight: 'auto',
  borderSize: '0',
  borderColor: 'transparent',
  hasBackground: false,
};
